import ApiClient from '../utils/ApiClient';

export default {
  methods: {
    async save(
      modelEndpoint,
      model,
      API = 'root',
      primaryKeyField = 'id',
      successTitle = 'Acción realizada exitosamente'
    ) {
      const isValid = await this.isValid();
      if (!isValid) {
        return;
      }
      const hasPrimaryKey = model[primaryKeyField];
      const apiClient = new ApiClient(modelEndpoint, API);
      if (!hasPrimaryKey) {
        return apiClient.Post(model).then(
          ({ data }) => {
            const { operationMessage, operationResult } = data;
            if (operationResult === -1) {
              this.setNotification(operationMessage, 'warning');
              return null;
            }
            if (operationResult === -2) {
              return {
                handleError: true,
              };
            }
            model[primaryKeyField] = operationResult;
            this.setNotification(operationMessage, 'success', successTitle);
            this.$root.$emit('reloadData');
            return model;
          },
          (err) => {
            this.setErrors(err.response.data);
          }
        );
      }
      return apiClient.Put(model).then(
        ({ data }) => {
          const { operationMessage, operationResult } = data;
          if (operationResult === -1) {
            this.setNotification(operationMessage, 'warning');

            return null;
          }
          this.setNotification(operationMessage, 'success', successTitle);
          this.$root.$emit('reloadData');
          return model;
        },
        (err) => {
          this.setErrors(err.response.data);
        }
      );
    },
    async isValid() {
      const valid = await this.$root.$children[0].$refs.validation.validate();
      return valid;
    },
    async resetValidators() {
      await this.$root.$children[0].$refs.validation.reset();
    },
    setErrors(errors) {
      this.$root.$children[0].$refs.validation.setErrors(errors);
    },
    setNotification(message, type = 'success', title = '', duration = 5000) {
      this.$store.dispatch('notifications/addNotification', {
        message,
        type,
        title,
        duration,
      });
    },
    getAll(modelEndpoint, query = '', API = 'root') {
      const apiClient = new ApiClient(modelEndpoint, API);
      return apiClient.Get(query);
    },
    $stream(modelEndpoint, query = '', API = 'root', method = 'POST', headers = null) {
      const apiClient = new ApiClient(modelEndpoint, API);
      return apiClient.stream(query, method, headers);
    },
    $post(modelEndpoint, query = {}, API = 'root') {
      const apiClient = new ApiClient(modelEndpoint, API);
      return apiClient.Post(query).then(({ data, headers }) => {
        return {
          data,
          headers,
        };
      });
    },
    $masiveDelete(modelEndpoint, query = {}, API = 'root') {
      const apiClient = new ApiClient(modelEndpoint, API);
      return apiClient.DeleteMasive(query).then(({ data, headers }) => {
        return {
          data,
          headers,
        };
      });
    },
    delete(
      modelEndpoint,
      id,
      API = 'root',
      callback = () => {},
      successTitle = 'Acción realizada exitosamente'
    ) {
      const apiClient = new ApiClient(modelEndpoint, API);
      return apiClient
        .Delete(id)
        .then(({ data }) => {
          if (data.result === 1 || data.operationResult === 1) {
            const operationMessage = data.message || data.operationMessage;
            this.setNotification(operationMessage, 'success', successTitle);
            this.$root.$emit('reloadData');
            callback();
          }
          return data;
        })
        .catch(({ response }) => {
          if (response.data.operationResult < 0) {
            this.setNotification(response.data.operationMessage, 'warning');
          }
        });
    },
    deleteItem(
      modelEndpoint,
      id,
      title,
      description,
      API = 'root',
      callback = () => {},
      successTitle = 'Acción realizada exitosamente'
    ) {
      this.showConfirm(title, description, 'danger', [
        {
          text: 'Cancelar',
          callback: () => {},
          props: {
            color: 'terciary-outlined',
          },
        },
        {
          text: 'Eliminar',
          callback: () => this.delete(modelEndpoint, id, API, callback, successTitle),
          props: {
            color: 'quinary',
          },
        },
      ]);
    },
    upload(modelEndpoint, query, API = 'root', onUploadProgress = () => {}) {
      const apiClient = new ApiClient(modelEndpoint, API);
      return apiClient.upload(query, 'POST', onUploadProgress);
    },
    showConfirm(title = '', description = '', type = '', actions = []) {
      this.$root.$emit('openConfirm', title, description, type, actions);
    },
    deleteForced(
      modelEndpoint,
      id,
      force = false,
      API = 'root',
      callback = () => {},
      successTitle = 'Acción realizada exitosamente'
    ) {
      const apiClient = new ApiClient(modelEndpoint, API);
      return apiClient
        .Delete(`${id}/${force}`)
        .then(({ data }) => {
          if (data.result === 1 || data.operationResult === 1) {
            const operationMessage = data.message || data.operationMessage;
            this.setNotification(operationMessage, 'success', successTitle);
            this.$root.$emit('reloadData');
            callback();
          }
          return data;
        })
        .catch(({ response }) => {
          if (response.data.operationResult < 0) {
            this.setNotification(response.data.operationMessage, 'warning');
          }
        });
    },
  },
};
